import React, { useEffect, useState } from "react";

function UserData({ meetingController }) {
  const [hostUser, setHostUser] = useState([]);

  useEffect(() => {
    const userContoller = meetingController.getUserController();

    (async () => {
      try {
        var response = await userContoller.getMeetingUsers();

        setHostUser(
          Object.values(response).filter((participant) => participant.isHost)
        );
      } catch (e) {
        console.log(e);
      }
    })();
  }, [meetingController]);

  return (
    <div className="user-data">
      <div>
        <span>Host User: </span>
        <span>{hostUser ? hostUser[0]?.displayName : ""}</span>
      </div>
    </div>
  );
}

export default UserData;
